import { useState, useContext, useEffect, useLayoutEffect, useMemo, Fragment } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  ListItemButton,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";

import {
  APP_BASE_URL,
  GET_ATTACHMENT_BY_ID,
  GET_COLLECTION_MAP_ID,
  GET_ASSET_FORM,
  APP_BASE_URL_ALARM,
  SUB_DEVICES_PATH,
  GET_ASSETS,
  trimAssetName,
  ASSET_MAINTENANCE_TABLE_API,
} from "./../../../Common/EndPoints";
import { AssetsData } from "../AssetsProvider";
import { Transition } from "../../../Modal/ModalConstants";
import CloseIcon from "@mui/icons-material/Close";
import noImage from "./noImage.jpg";
import "./InfoPopup.scss";
import { showSection } from "./FormRender";
import { getGenericAttachment } from "./assetRegisterUtils";
import { toast } from "react-hot-toast";
import { downloadFile } from "../../../Utils/Utils";
import { PeridioCityTerminologies } from "../Maintenance/MaintenanceConstants";
import { useImmer } from "use-immer";
import MaintenanceDataTable from "../Maintenance/MaintenaceTable/MaintenanceDataTable";
import { AssetComponentReplacementHistory } from "../AssetComponentReplacement/AssetComponentReplacementHistory";
import { AssetComponentReplacement } from "../AssetComponentReplacement/AssetComponentReplacement";

const keys = {
  codal: "Codal Life (In Years)",
  code: "Asset Code",
  connected: "Connected to",
  division: "Division",
  gear: "Asset Position",
  gearType: "Asset type",
  gear_name: "Asset Name",
  install: "Installation Date",
  lat: "Latitude",
  lon: "Longitude",
  maintenance: "Maintenance Start Date",
  make: "Make",
  manufacture: "Manufactured Date",
  model: "model",
  platform: "Platform Number",
  po: "PO Number",
  pole: "Pole KM",
  purchase: "Purchased Date",
  remarks: "Remarks",
  rfid: "QRID",
  serial: "Serial Number",
  station: "Station",
  subType: "Sub Type",
  warrenty: "Warrenty Expiry Date",
  zone: "Zone",
  system: "System",
};
const keysToShowWhenValueExist = {
  cable_type: "Cable Type",
  link_between: "Link Between",
  number_of_strands: "Number of strands",
  monitoring_strands_number: "Monitoring Strands Number",
}

const NavigationTabs = ({ activeTab, setActiveTab, additionalFormData, setSnackbarMessage }) => {
  const [additionalInfo, setAdditionalInfo] = useState(false);
  useEffect(() => {
    if (additionalFormData.length > 0) {
      let responsesCount = 0;
      additionalFormData.forEach((data) => {
        if (data.responses) {
          responsesCount += 1;
        }
      });
      if (responsesCount > 0) {
        setAdditionalInfo(true);
      }
    }
  }, [additionalFormData]);
  const _tabs = ["General Info", "Connected Device(s)", "Maintenance History", "Replacement", "Replacement History"];
  if (additionalInfo) _tabs.push("Additional Info");
  return (
    <div className="assets-info-popup-navigation-tabs flex">
      {_tabs.map((key, index) => {
        return (
          <div
            key={key + index}
            className={`pointer info-popup-navigation-tab ${activeTab === index && "info-popup-navigation-tab-active"}`}
            onClick={() => setActiveTab(index)}
          >
            {key}
          </div>
        );
      })}
    </div>
  );
};
const Attachments = ({ attachmentsData }) => {
  return (
    <div className="object-data-viewer-list-item flex spaceBetween">
      <span className="object-data-viewer-list-item-key">Attachments</span>
      <div className="object-data-viewer-list-item-separator">:</div>
      <span className="object-data-viewer-list-item-value flex flexDirectionColumn">
        {attachmentsData.map((file, index) => {
          const { name, path, type } = file;
          if (type !== "Gear Type Image") {
            return (
              <a
                className="assets__info__attachment--link cursor-pointer"
                href={`${APP_BASE_URL}${GET_ATTACHMENT_BY_ID}/${file.id}?isDownload=true`}
              >
                {file.name}
              </a>
            );
          }
        })}
      </span>
    </div>
  );
};

function handleAttachmentDownload({ url, name }) {
  const toastId = toast.loading("Exporting...");
  axios
    .get(url, { responseType: "blob" })
    .then(
      (response) => {
        const data = response.data;
        downloadFile({ data, name });
      },
      async (err) => {
        const text = JSON.parse(await err.response.data.text());
        toast.error(text.error);
      },
    )
    .then(() => {
      toast.dismiss(toastId);
    });
}

const AttachmentNode = ({ fieldData, form_values }) => {
  const [files, setFiles] = useState([]);
  useEffect(() => {
    const ids = form_values?.[fieldData.key] ?? [];
    if (ids.length === 0) return;
    const params = { ids: ids.toString(), entity: "form" };
    getGenericAttachment(params).then((res) => {
      setFiles(res.data);
    });
  }, []);
  // const fieldValue = form_values[fieldData.key]?.toString();

  return (
    <li key={fieldData.key} className="object-data-viewer-list-item">
      <span className="object-data-viewer-list-item-key">{fieldData.label}</span>
      <span className="object-data-viewer-list-item-value flex flex-col">
        {files.map((file, index) => (
          <span className="flex gap-2 items-center">
            {index + 1}.
            <div
              className="assets__info__attachment--link cursor-pointer"
              onClick={() => {
                const url = `${APP_BASE_URL_ALARM}/${file.path}`;
                handleAttachmentDownload({ url, name: file.name });
              }}
            >
              {file.name}
            </div>
          </span>
        ))}
      </span>
    </li>
  );
};

const RenderField = ({ fieldData, form_values }) => {
  switch (fieldData.type) {
    case "section": {
      return (
        <div className="assets__info-popup__section" key={fieldData.key}>
          <h4 className="assets__info-popup__section--title">{fieldData.label}</h4>
          {fieldData.sectionFields.map((field) => (
            <RenderField fieldData={field} form_values={form_values} key={field.key} />
          ))}
        </div>
      );
    }
    case "reactive-section":
    case "reactive_section": {
      const reactiveValue = fieldData.reactiveValue;
      const parentKey = fieldData.reactiveKey;
      const parentValues = form_values[parentKey];
      if (showSection({ parentValues, reactiveValue })) {
        return (
          <div className="assets__info-popup__section" key={fieldData.key}>
            <h4 className="assets__info-popup__section--title">{fieldData.label}</h4>
            {fieldData.sectionFields.map((field) => (
              <RenderField fieldData={field} form_values={form_values} key={field.key} />
            ))}
          </div>
        );
      }
      return <></>;
    }
    case "reactive_dropdown":
    case "reactive-dropdown": {
      let showDropdown = fieldData.showInitially;
      const reactiveValue = fieldData.reactiveValue;
      const parentKey = fieldData.reactiveKey;
      const parentValues = form_values[parentKey];

      Object.entries(reactiveValue).forEach(([option, value]) => {
        if (Array.isArray(parentValues) && parentValues.includes(option)) {
          showDropdown = true;
        } else if (parentValues === option) {
          showDropdown = true;
        }
      });

      if (!showDropdown) return <></>;
      return (
        <RenderField form_values={form_values} fieldData={{ ...fieldData, type: "dropdown" }} key={fieldData.key} />
      );
    }
    case "attachment":
      return <AttachmentNode fieldData={fieldData} form_vaues={form_values} key={fieldData.key} />;
    default: {
      const fieldValue = form_values[fieldData.key]?.toString();
      return (
        <li key={fieldData.key} className="object-data-viewer-list-item flex spaceBetween">
          <span className="object-data-viewer-list-item-key">{fieldData.label}</span>
          <div className="object-data-viewer-list-item-separator">:</div>
          <span className="object-data-viewer-list-item-value">{fieldValue}</span>
        </li>
      );
    }
  }
};

const AdditionalInfoFormData = ({ data = {} }) => {
  const { data: form = [], responses = {} } = data;

  const fieldProps = { form_values: responses?.[0]?.data };
  return (
    <ul>
      {form.map((field) => (
        <RenderField fieldData={field} {...fieldProps} key={field.key} />
      ))}
    </ul>
  );
};

const AdditionalInfoDataContainer = ({ additionalFormData = [] }) => {
  const { attachmentsData, setFormId, formId } = useContext(AssetsData);
  const tabsData = useMemo(() => {
    const ids = [];
    const entities = {};
    additionalFormData.forEach((form, index) => {
      ids.push(form.id);
      entities[form.id] = form;
      if (index === 0) setFormId(form.id);
    });
    return { ids, entities };
  }, [additionalFormData]);
  function handleFormChange(_formId) {
    setFormId(_formId);
  }
  return (
    <div className="assets-info-popup-tab-view-container flex spaceBetween">
      <div className="assets-info-popup-tab-sections maxContent">
        {tabsData.ids.map((_formId, index) => (
          <List
            key={"assets-tab-section" + index}
            className={formId === _formId ? "info-popup-tab-active" : "info-popup-tab"}
          >
            <ListItem disablePadding onClick={() => handleFormChange(_formId)}>
              <ListItemButton>{tabsData.entities[_formId].name}</ListItemButton>
            </ListItem>
          </List>
        ))}
      </div>
      <div className="assets-info-popup-tab-data fullFlexBasis">
        <AdditionalInfoFormData data={tabsData.entities[formId]} />
        <Attachments attachmentsData={attachmentsData} />
      </div>
    </div>
  );
};

const ConnectedDevices = ({ connected_device_list = [] }) => {
  return (
    <div style={{ padding: "0.5rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
      {connected_device_list.map((device_info, index) => (
        <div>
          {index + 1}. {device_info.name}
          <ObjectDataViewer object={device_info} labelObject={keys} />
        </div>
      ))}
    </div>
  );
};

const ConnectedDevicesWrapper = ({ parent_device }) => {
  const [state, setState] = useState({ connected_devices: [], loading: true });
  const { deviceId = "" } = parent_device;

  async function getConnectedDeviceList() {
    try {
      const response = await axios.get(APP_BASE_URL + SUB_DEVICES_PATH, { params: { deviceId } });
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }

  async function getDevicesInfo(params) {
    try {
      const response = await axios.get(APP_BASE_URL + GET_ASSETS, { params });
      return response.data.data.map((device) => ({
        ...device,
        ...device.additionaldetail,
        name: trimAssetName(device.name),
      }));
    } catch (error) {
      throw error;
    }
  }
  async function getConnectedDeviceListWithInfo() {
    try {
      const devices_list = await getConnectedDeviceList();
      if (!devices_list || devices_list.length === 0) {
        setState({ connected_devices: [], loading: false });
        return;
      }
      const devices_info = await getDevicesInfo({ deviceIds: devices_list.toString() });

      setState({ connected_devices: devices_info, loading: false });
    } catch (error) {
      console.error("FETCH_CONNECTED_DEVICES_WITH_INFO", error);
      setState((state) => ({ ...state, loading: false }));
    }
  }
  useEffect(() => getConnectedDeviceListWithInfo(), []);

  if (state.loading) {
    return (
      <div style={{ width: "100%", height: "100%" }} className="flex items-center justify-center">
        <CircularProgress />
      </div>
    );
  }
  if (state.connected_devices.length === 0) {
    return (
      <div style={{ width: "100%", height: "100%" }} className="flex items-center justify-center">
        <div>No device(s) are connected with this device</div>
      </div>
    );
  }
  return <ConnectedDevices connected_device_list={state.connected_devices} />;
};

function getAdditionalFieldBasedOnSystem(system, keys) {
  const _keys = { ...keys };
  if (system === "FMS") {
    _keys.fams_link_id = "FAMS LINK ID"
  }
  return _keys;
}

const PopupData = ({ infoData, attachmentsData, additionalFormData, activeTab, setFormId }) => {
  const _keys = getAdditionalFieldBasedOnSystem(infoData.system, keys)
  const entries = Object.entries(infoData?.additionaldetail || {})
  .filter(([key, value]) => value && !Object.keys(_keys).includes(key));
  function getTabContent() {
    switch (activeTab) {
      case 0:
        return (
          <>
            <ObjectDataViewer object={infoData} labelObject={_keys} />

            <ul>
              {entries
                .map(([key, value], index) => {
                  const isFirst = index === 0;
                  const isLast = index === entries.length - 1;

                  return (
                    <li key={key} className="object-data-viewer-list-item flex spaceBetween" 
                      // style={{ 
                      //   borderTop: isFirst ? "2px solid rgb(218, 218, 218)": undefined, 
                      //   borderBottom: isLast ? "2px solid rgb(218, 218, 218)": undefined 
                      // }}
                    >
                      <span className="object-data-viewer-list-item-key">{key}</span>
                      <div className="object-data-viewer-list-item-separator">:</div>
                      <span className="object-data-viewer-list-item-value">{value}</span>
                    </li>
                  );

                })}
            </ul>
            {/* <ObjectDataConditionalViewer object={infoData} labelObject={keysToShowWhenValueExist} /> */}
            <Attachments attachmentsData={attachmentsData} />
          </>
        );
      case 1:
        return <ConnectedDevicesWrapper parent_device={infoData} />;
      case 2:
        return <MaintenanceHistoryWrapper parent_device={infoData} />;
      case 3:
        return <AssetComponentReplacement DEVICE_ID={infoData.deviceId} gearType={infoData.gearType} defaultValues={infoData} gear_name={infoData?.gear_name} />
      case 4:
        return <AssetComponentReplacementHistory DEVICE_ID={infoData.deviceId} gearTypeValue={infoData.gearType} />;
      default:
        return <AdditionalInfoDataContainer infoData={infoData} additionalFormData={additionalFormData} />;
    }
  }
  function getImageContainer() {
    switch (activeTab) {
      case 0:
        return <ImageViewerContainer attachmentsData={attachmentsData} />;
      case 1:
      case 2:
      case 3:
        return null;
      default:
        return <ImageViewerContainer attachmentsData={attachmentsData} />
    }
  }
  const tab_content = getTabContent();
  const imageContainer = getImageContainer();
  return (
    <Fragment key={activeTab}>
      <div className="assets-info-popup-data-info maxContent fullFlexBasis">
        {tab_content}
      </div>
      {imageContainer}
    </Fragment>
  );
};

const MaintenanceHistoryWrapper = ({ parent_device }) => {
  const initialPaginantion = {
    pageIndex: 0,
    pageSize: 20,
    totalRowCount: 0,
  };
  const { deviceId } = parent_device;
  const [state, setState] = useImmer({
    loader: true,
    rowsData: [],
  });
  const [paginantion, setPaginantion] = useImmer(initialPaginantion);

  const getMaintenanceHistory = async () => {
    setState((state) => {
      state.loader = true;
    });
    let url = `${APP_BASE_URL}${ASSET_MAINTENANCE_TABLE_API}`;
    let params = {
      deviceIds: deviceId,
      withResponse: true,
      page: paginantion.pageIndex + 1,
      pageSize: paginantion.pageSize,
      withScheduleAssignment: true,
    };

    axios.get(url, { params }).then((res) => {
      setPaginantion((state) => {
        state.totalRowCount = res.data.data.totalElements;
      });
      let Response = res.data.data.content.map((row, i) => {
        let assetName = trimAssetName(row.gearName);
        return {
          ...row,
          id: i,
          gearName: assetName,
          system: row.software.code,
          periodicity: PeridioCityTerminologies[row.periodicity] ?? "",
          designation: row.designation ? row.designation : row.scheduleAssignment.userRoleName ?? "-",
        };
      });
      setState((state) => {
        state.rowsData = Response;
        state.loader = false;
      });
    });
  };

  useEffect(() => {
    getMaintenanceHistory();
  }, []);


  return (
    <div className="fullHeight maintenance-info-table-container">
      <MaintenanceDataTable
        loader={state.loader}
        rowsData={state.rowsData}
        paginantion={paginantion}
        setPaginantion={setPaginantion}
      />
    </div>
  );
};

const ObjectDataViewer = ({ object, labelObject }) => {
  return (
    <ul>
      {Object.entries(object).map(([key, value], index) => {
        if (!labelObject || labelObject?.[key]) {
          return (
            <li key={key + index} className="object-data-viewer-list-item flex spaceBetween">
              <span className="object-data-viewer-list-item-key">{labelObject ? labelObject[key] : key}</span>
              <div className="object-data-viewer-list-item-separator">:</div>
              <span className="object-data-viewer-list-item-value">{value}</span>
            </li>
          );
        }
      })}
    </ul>
  );
};
const ObjectDataConditionalViewer = ({ object, labelObject }) => {
  return (
    <ul>
      {Object.entries(object).map(([key, value], index) => {
        if (!labelObject || labelObject?.[key] && value) {
          return (
            <li key={key + index} className="object-data-viewer-list-item flex spaceBetween">
              <span className="object-data-viewer-list-item-key">{labelObject ? labelObject[key] : key}</span>
              <div className="object-data-viewer-list-item-separator">:</div>
              <span className="object-data-viewer-list-item-value">{value}</span>
            </li>
          );
        }
      })}
    </ul>
  );
};

const ImageViewerContainer = ({ attachmentsData }) => {
  const [gearTypeImages, setGearTypeImages] = useState([]);
  // const [imageLoading, setImageLoading] = useState(true);
  const [currentPreviewImage, setCurrentPreviewImage] = useState(0);

  function handlePreviousPreviewImage() {
    if (currentPreviewImage !== 0) setCurrentPreviewImage((previousValue) => previousValue - 1);
  }
  function handleNextPreviewImage() {
    if (currentPreviewImage !== gearTypeImages.length - 1) setCurrentPreviewImage((previousValue) => previousValue + 1);
  }
  useEffect(() => {
    const displayImages = attachmentsData.reduce(function (accumulator, { type, path, id }) {
      if (type === "Gear Type Image") {
        // accumulator.push(`${APP_BASE_URL}/${path}`);
        accumulator.push(`${APP_BASE_URL}${GET_ATTACHMENT_BY_ID}/${id}`);
      }
      return accumulator;
    }, []);
    setGearTypeImages(displayImages);
  }, [attachmentsData]);
  // useEffect(() => {
  //   if (gearTypeImages[currentPreviewImage]) {
  //     setImageLoading(true);
  //   } else setImageLoading(false);
  // }, [gearTypeImages, currentPreviewImage]);
  return (
    <div className="assets-info-popup-attachment-info-container">
      <div className="assets-info-popup-image">
        {/* {imageLoading && (
          <div
            style={{
              width: "100%",
              backgroundColor: "#e6e6e6",
              height: "15em",
            }}
          ></div>
        )} */}
        <a href={gearTypeImages[currentPreviewImage] ?? null} target="_blank" rel="noreferrer">
          <img
            loading="lazy"
            // onLoad={() => {
            //   setImageLoading(false);
            // }}
            key={currentPreviewImage}
            // style={{ width: "100%", height: "100%", objectFit: "contain" }}
            style={{ width: "18em", height: "18em", objectFit: "contain" }}
            src={gearTypeImages[currentPreviewImage] ?? noImage}
            alt="Not Available"
          />
        </a>
      </div>
      {gearTypeImages.length > 0 && (
        <div className="assets-images-preview-container flex alignCenter spaceBetween">
          <div
            className={`assets-images-preview-previous-navigation ${currentPreviewImage === 0 ? "notAllowed" : "pointer"
              }`}
            onClick={handlePreviousPreviewImage}
          ></div>
          <div>
            {currentPreviewImage + 1} of {gearTypeImages.length}
          </div>
          <div
            className={`assets-images-preview-forward-navigation ${currentPreviewImage === gearTypeImages.length - 1 ? "notAllowed" : "pointer"
              }`}
            onClick={handleNextPreviewImage}
          ></div>
        </div>
      )}
    </div>
  );
};

function InfoPopup({ open, onClose, label, infoData }) {
  const { attachmentsData, setFormId, setAttachmentsData } = useContext(AssetsData);
  const [additionalFormData, setAdditionalFormData] = useState([]);
  const [snackbarMessage, setSnackbarMessage] = useState(null);
  useEffect(() => {
    const url = `${APP_BASE_URL}${GET_COLLECTION_MAP_ID}?type_id=${infoData.typeid}`;
    axios.get(url).then(({ data }) => {
      const url2 = `${APP_BASE_URL}${GET_ASSET_FORM}?collection_map_id=${data[0].collectionmapid}&with_responses=true&device_id=${infoData.deviceId}`;
      axios.get(url2).then(({ data }) => {
        setAdditionalFormData(data.data);
      });
    });
  }, []);
  const [activeTab, setActiveTab] = useState(0);
  useLayoutEffect(() => {
    if (activeTab === 0) {
      setFormId("");
      // setAttachmentsEdit(false);
    }
    // setAttachmentsData([]);
    // else {
    // }
  }, [activeTab]);
  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        className="assets-information-popup"
        TransitionComponent={Transition}
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogTitle id="responsive-dialog-title" className="flex">
          {label}
          <CloseIcon
            className="assets-info-popup-close-icon pointer"
            onClick={() => {
              onClose(false);
            }}
          />
        </DialogTitle>
        <DialogContent dividers>
          <div className="assets-info-popup-content-container fullWidth flex flexDirectionColumn">
            <NavigationTabs
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              additionalFormData={additionalFormData}
              setSnackbarMessage={setSnackbarMessage}
            />
            <div className="assets-info-popup-data-container flex spaceEvenly">
              <PopupData
                infoData={infoData}
                attachmentsData={attachmentsData}
                activeTab={activeTab}
                additionalFormData={additionalFormData}
                setFormId={setFormId}
              />
              {/* <ImageViewerContainer attachmentsData={attachmentsData} /> */}
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            autoFocus
            onClick={() => {
              onClose(false);
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={snackbarMessage ? true : false} autoHideDuration={6000} onClose={() => setSnackbarMessage(null)}>
        <Alert severity="error" className="fullWidth">
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default InfoPopup;
